// Build the complete product-owned brand directory without a Liquid loop/page-size cutoff.
function bindBrands() {
  for (const data of document.querySelectorAll('[data-brand-names]:not([data-bound])')) {
    const section = data.closest('[data-product-group-section]')
    const track = section?.querySelector('.brandshelf')
    if (!track) continue
    let names
    try { names = JSON.parse(data.textContent) } catch { continue }
    if (!Array.isArray(names)) continue
    data.dataset.bound = 'true'
    const existing = new Map([...track.querySelectorAll('.brandtile')].map(tile => [new URL(tile.href).searchParams.get('q')?.trim().toLowerCase(), tile]))
    const unique = new Map()
    for (const name of names) if (typeof name === 'string' && name.trim()) {
      const key = name.trim().toLowerCase()
      if (!unique.has(key)) unique.set(key, name.trim())
    }
    const fragment = document.createDocumentFragment()
    for (const [key, name] of [...unique].sort((a, b) => a[1].localeCompare(b[1], document.documentElement.lang || undefined))) {
      let tile = existing.get(key)
      if (!tile) {
        tile = document.createElement('a')
        tile.className = 'brandtile'
        const url = new URL(data.dataset.brandUrl, location.origin)
        url.searchParams.set('q', name)
        tile.href = url.href
        tile.setAttribute('data-brand-logo-card', '')
        const media = document.createElement('span')
        media.className = 'brandtile__media'
        media.setAttribute('data-group-media', '')
        const label = document.createElement('span')
        label.className = 'brandtile__name'
        label.textContent = name
        const count = document.createElement('span')
        count.className = 'brandtile__n'
        count.setAttribute('data-group-count', '')
        tile.append(media, label, count)
      }
      tile.dataset.brandKey = key
      if (tile.dataset.brandState !== 'ready') {
        tile.hidden = true
        tile.style.display = 'none'
      }
      fragment.append(tile)
    }
    track.replaceChildren(fragment)
    // Hidden cards cannot intersect. Validate a bounded batch, then refill near the track's end.
    let scheduled = false
    const pump = () => {
      if (!track.isConnected) {
        document.removeEventListener('opensku:brand-resolved', schedule)
        window.removeEventListener('resize', schedule)
        return
      }
      if (track.scrollWidth - track.clientWidth - Math.abs(track.scrollLeft) > Math.max(track.clientWidth, 600)) return
      const cards = [...track.children]
      const active = cards.filter(card => ['loading', 'queued'].includes(card.dataset.brandState)).length
      const batch = cards.filter(card => !card.hasAttribute('data-group-bound') && card.dataset.brandState !== 'queued').slice(0, Math.max(0, 12 - active))
      for (const card of batch) {
        card.dataset.brandState = 'queued'
        card.setAttribute('data-product-group', '')
      }
      if (batch.length) document.dispatchEvent(new CustomEvent('opensku:shelves-added'))
    }
    const schedule = () => {
      if (scheduled) return
      scheduled = true
      setTimeout(() => { scheduled = false; pump() }, 100)
    }
    track.addEventListener('scroll', schedule, { passive: true })
    window.addEventListener('resize', schedule)
    document.addEventListener('opensku:brand-resolved', schedule)
    schedule()
    document.dispatchEvent(new CustomEvent('opensku:shelves-added'))
  }
}
bindBrands()
document.addEventListener('shopify:section:load', bindBrands)
document.addEventListener('opensku:shelves-added', bindBrands)
